import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { commitImport } from '@/api/clientImports/clientImportsApi';
import type { ImportCommitResult, ImportPreviewRow } from '@/api/clientImports/clientImportsApi.types';
import { CLIENTS_QUERY_KEY, PATIENTS_QUERY_KEY } from '@/constants/queryKeys';

interface CommitImportVariables {
  rows: ImportPreviewRow[];
  idempotencyKey: string;
}

export function useCommitImportMutation(): UseMutationResult<
  ImportCommitResult,
  Error,
  CommitImportVariables
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: function commit(variables: CommitImportVariables) {
      return commitImport(variables.rows, variables.idempotencyKey);
    },
    onSuccess: function invalidateAfterCommit() {
      queryClient.invalidateQueries({ queryKey: CLIENTS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: PATIENTS_QUERY_KEY });
    },
  });
}
